const TradingDeskActionTypes = {
    START_ACCOUNT_DEPOSIT: 'START_ACCOUNT_DEPOSIT',
    SUCCESS_ACCOUNT_DEPOSIT: 'SUCCESS_ACCOUNT_DEPOSIT',
    FINISH_ACCOUNT_DEPOSIT: 'FINISH_ACCOUNT_DEPOSIT',
    FAILURE_ACCOUNT_DEPOSIT: 'FAILURE_ACCOUNT_DEPOSIT',

    START_ACCOUNT_WITHDRAW: 'START_ACCOUNT_WITHDRAW',
    SUCCESS_ACCOUNT_WITHDRAW: 'SUCCESS_ACCOUNT_WITHDRAW',
    FINISH_ACCOUNT_WITHDRAW: 'FINISH_ACCOUNT_WITHDRAW',
    FAILURE_ACCOUNT_WITHDRAW: 'FAILURE_ACCOUNT_WITHDRAW',

    START_ADD_ACCOUNT: 'START_ADD_ACCOUNT',
    SUCCESS_ADD_ACCOUNT: 'SUCCESS_ADD_ACCOUNT',
    FINISH_ADD_ACCOUNT: 'FINISH_ADD_ACCOUNT',
    FAILURE_ADD_ACCOUNT: 'FAILURE_ADD_ACCOUNT',

    START_EXCHANGE: 'START_EXCHANGE',
    SUCCESS_EXCHANGE: 'SUCCESS_EXCHANGE',
    FINISH_EXCHANGE: 'FINISH_EXCHANGE',
    FAILURE_EXCHANGE: 'FAILURE_EXCHANGE',

    START_GET_EXCHANGE_RATE: 'START_GET_EXCHANGE_RATE',
    SUCCESS_GET_EXCHANGE_RATE: 'SUCCESS_GET_EXCHANGE_RATE',
    FINISH_GET_EXCHANGE_RATE: 'FINISH_GET_EXCHANGE_RATE',
    FAILURE_GET_EXCHANGE_RATE: 'FAILURE_GET_EXCHANGE_RATE',

    START_GET_EXCHANGE_FEE: 'START_GET_EXCHANGE_FEE',
    SUCCESS_GET_EXCHANGE_FEE: 'SUCCESS_GET_EXCHANGE_FEE',
    FINISH_GET_EXCHANGE_FEE: 'FINISH_GET_EXCHANGE_FEE',
    FAILURE_GET_EXCHANGE_FEE: 'FAILURE_GET_EXCHANGE_FEE',

    START_MAX_FEES_V2: 'START_MAX_FEES_V2',
    SUCCESS_MAX_FEES_V2: 'SUCCESS_MAX_FEES_V2',
    FINISH_MAX_FEES_V2: 'FINISH_MAX_FEES_V2',
    FAILURE_MAX_FEES_V2: 'FAILURE_MAX_FEES_V2',
}

export default TradingDeskActionTypes
